import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Form, useFormikContext } from 'formik';

import { Loader } from 'src/components/Loader';

import { SwitchContainer } from './SwitchContainer';
import { EditContractorForm } from './EditContractorForm';
import { EditCustomerForm } from './EditCustomerForm';
import { useProfileWidgetStore } from './StoreProvider';

export const EditForm = observer(() => {
  const { isEditLoading } = useProfileWidgetStore();

  const { resetForm } = useFormikContext();

  useEffect(() => resetForm, [resetForm]);

  return isEditLoading ? (
    <Loader />
  ) : (
    <Form>
      <div className="mt-2">
        {/* Приходится затыкать типизацию, потому что вариант не поддерживается в типах, но поддерживается в коде react-bootstrap */}
        <SwitchContainer Contractor={EditContractorForm} Customer={EditCustomerForm} />
      </div>
    </Form>
  );
});
